import React from 'react';
import ReactDOM from 'react-dom';
import CmdTypeActions from '../actions/CmdTypeActions';
import CommandActions from '../actions/CommandActions';
import FocusActions from '../actions/FocusActions';

import Cmd from '../forms/sys/remote/Cmd';
import CommandArg from '../forms/sys/remote/CommandArg';
import FormParam from '../forms/sys/remote/FormParam';
import ContextMapArg from '../forms/sys/remote/ContextMapArg';
import ArgCallerType from '../forms/sys/ArgCallerType';
import CommandArgGroupInfo from '../forms/sys/remote/CommandArgGroupInfo';
import DialogForm from '../components/dialog/DialogForm';

import StringUtil from './StringUtil';
import QueryUtil from './QueryUtil';
import GOTUtil from './GOTUtil';
import FormItemUtil from './FormItemUtil';
import RecordsUtil from './RecordsUtil';
import CommonUtil from './CommonUtil';
import Fade from './Fade';
import Warning from './Warn';
import FormLoadHelper from './FormLoadHelper';
import FormResourceUtil from './FormResourceUtil';
import CommandHelper from '../remote/CommandHelper';
import ServiceHelper from '../remote/ServiceHelper';
import CommandTask from '../forms/sys/remote/CommandTask';

import FormParamCondition from '../forms/sys/remote/FormParamCondition';
import TimerTasksUtil from './TimerTasksUtil';
import FormDataSourceGroupArg from '../forms/sys/datasource/FormDataSourceGroupArg';
import FocusController from '../components/FocusController';
import RemotePasteDialog from './RemotePasteDialog';

import LayerManager from '../manager/LayerManager';
import Attachment from '../components/attachment/Attachment';
import ResizeActions from '../actions/ResizeActions';

class CommandResolver
{

	static getParentFormModule(calleruuId)
	{
		let parentFormModuleObj = {};
		$("#g_tab_content .tab-pane iframe",window.parent.document).each(
			function()
			{
				var iframeSrc = this.src;
				if(iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0)
				{
					return true;
				}
				if(this.contentWindow.formModuleInstanceuuId == calleruuId)
				{
					parentFormModuleObj.parentFormModule = this.contentWindow.formModuleInstance;
					parentFormModuleObj.window = this.contentWindow;
					return false;
				}
			}
		);
		if(parentFormModuleObj.parentFormModule)return parentFormModuleObj;
		var popIframes = $("#formModal iframe",window.parent.document);
		for(var i = 0;i<popIframes.length;i++)
		{
			var iframe = popIframes.get(i);
			var iframeSrc = iframe.src;
			if(iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0)
			{
				continue;
			}
			if(iframe.contentWindow.formModuleInstanceuuId == calleruuId)
			{
				parentFormModuleObj.parentFormModule = iframe.contentWindow.formModuleInstance;
				parentFormModuleObj.window = iframe.contentWindow;
			}
		}

		return parentFormModuleObj;
	}

	static getFormParam(formModule, defaultGroupAlias)
	{
		var formParam = new FormParam();	
		var isForLookup = (formModule.classAlias == "FormModuleLookup");
		formParam.menuItemId = isForLookup?"FormLookup":window.menuItemId;
		formParam.formId = formModule.props.formId;
		var argCaller = isForLookup?formModule.props.argCaller:window.argCaller;
		if(argCaller)
		{
			formParam.callerFormId = argCaller.callerFormId;
			formParam.callerMenuItemId = argCaller.callerMenuItemId;
			formParam.callerType = argCaller.callerType;
			formParam.callerKey = argCaller.callerKey;
			
			formParam.joinTableAlias = argCaller.joinGroupAlias;
			formParam.joinTableName = argCaller.joinTableName;
			
			formParam.paramString = argCaller.parameters;
			formParam.paramObject = argCaller.paramObject;
			if(formParam.paramObject && typeof(formParam.paramObject) == "object")
			{
			  formParam.paramObject = Object.assign({remoteClass:"java.util.Map"},formParam.paramObject);
			}
			//if(argCaller.type==ArgCallerType.StringEditor)
			//{
				//TODO 下拉指定画面时 要存入当前current(3)的CommandArg到sessionStorage
				//key为menuItemId+formId
				if(argCaller.calleruuId)
				{
					var parentModuleObj = CommandResolver.getParentFormModule(argCaller.calleruuId);
					var parentModule = parentModuleObj.parentFormModule;
					if(parentModule)
					{
						var parentMethodinfo = {remoteClass:"gongqi.erp.gotmodel.form.remote.CommandArgMethodInfo"};
						parentMethodinfo.fetchOption = true;
						if(argCaller.commandArgInfo)
						{
							parentMethodinfo.groups = argCaller.commandArgInfo;
						}
						else
						{
							parentMethodinfo.groups = "all(4)";
						}
						parentMethodinfo.editors = "all";
						parentMethodinfo.joinGroup = "yes";
						defaultGroupAlias = null;
						if(parentModule.formDataSources && parentModule.formDataSources.currentGroup)
						{
							defaultGroupAlias = parentModule.formDataSources.currentGroup.groupAlias;
						}
						var parentArg = parentModuleObj.window.getSendCmd(parentModule,defaultGroupAlias,parentMethodinfo);
						
							//CommandResolver.getSendCmd(parentModule,defaultGroupAlias,parentMethodinfo,parentModuleObj.window);
						formParam.callerCommandArg = parentArg;
					}

					if(argCaller.type == ArgCallerType.StringEditor)
						formParam.callerLookupField = argCaller.callerDataField;
				}
				

			//}
		}
		
		return formParam;
	}

	static numToReg(num,_group,formModule,arg,isJoinGroup=false)
	{
		if(_group == null)
			return;
		if(num == "0")
		{
			CommandResolver.regCmdArgGroup(formModule,arg,_group,isJoinGroup,false,false,false,false,false);
		}
		else if(num == "1")
		{
			CommandResolver.regCmdArgGroup(formModule,arg,_group,isJoinGroup,true,false,false,false,false);
		}
		else if(num == "2")
		{
			CommandResolver.regCmdArgGroup(formModule,arg,_group,isJoinGroup,true,true,false,false,false);
		}
		else if(num == "3")
		{
			CommandResolver.regCmdArgGroup(formModule,arg,_group,isJoinGroup,true,false,false,true,true);
		}
		else if(num == "4")
		{
			CommandResolver.regCmdArgGroup(formModule,arg,_group,isJoinGroup,true,true,false,true,true);
		}
		else
		{
			var nums = num.split(",");
			var currentRecord = false;
			var selectedsRecords = false;
			var allRecords = false;
			var currentQuery = false;
			var formQuery = false;
			
			if(nums.indexOf("cr") != -1)
			{
				currentRecord = true;
			}
			if(num.indexOf("sr") != -1)
			{
				selectedsRecords = true;
			}
			if(num.indexOf("ar") != -1)
			{
				allRecords = true;
			}
			if(num.indexOf("cq") != -1)
			{
				currentQuery = true;
			}
			if(num.indexOf("fq") != -1)
			{
				formQuery = true;
			}
			
			CommandResolver.regCmdArgGroup(formModule,arg,_group,isJoinGroup,currentRecord,selectedsRecords,allRecords,currentQuery,formQuery);
		}
	}

	static regCmdArgGroup(formModule,arg,_group,isJoinGroup,currentRecord,selectedRecords,allRecords,currentQuery,formQuery)
	{
		if(_group == null)
			return;
		var gi = new CommandArgGroupInfo();
		if(isJoinGroup==true)
			arg.joinGroup = gi;
		else
			arg.mapGroups[_group.groupAlias] = gi;
		
		gi.formId = formModule.classAlias=="FormModuleLookup"?formModule.props.formId:window.formId;
		gi.groupAlias = _group.groupAlias;
		gi.mainSourceTableName = _group.tableName;
		if(window.lastEditedDataFields)
		{
			gi.currentDataField = window.lastEditedDataFields[_group.groupAlias];
		}
		
		if(currentRecord)
		{
			let _currentRecord = {remoteClass:"java.util.HashMap"};
			let hasSecond = false;
			for(let i = 0;i<_group.sources.length;i++)
			{
				var sourceName = _group.sources[i].sourceName;
				let secondRec = RecordsUtil.getSecondaryRecord(_group.currentRecord,sourceName);
				if(secondRec)hasSecond = true;
				_currentRecord[sourceName] = secondRec;
			}
			gi.currentRecord = hasSecond?_currentRecord:null;
		}
			
		
		// TODO 对于不在同画面的关联数据源 joinGroup中dataProvider的处理待定 有可能取消 因为
		// 只在浮动式下比较有意义
		if(selectedRecords)
		{
			var _selectRecordsKeys = []
			CommandActions.getSelectRecordsKey(_selectRecordsKeys,_group.groupAlias,formModule.menuItemId,formModule.formId,formModule.instanceUUId);
			var _selectRecordsKey = _selectRecordsKeys.length>0?_selectRecordsKeys[0]:null;

			if(_selectRecordsKey)
			{
				gi.selectedRecords = [];gi.hasColumnAsSysSelectRecords = true;
				for(var i=0;i<_group.records.length;i++)
				{
					var item = _group.records[i];
					var value = item[_selectRecordsKeys];
					if(value == true || value == "true")
					{

						let _currentRecord = {remoteClass:"java.util.HashMap"};
						for(let i = 0;i<_group.sources.length;i++)
						{
							let sourceName = _group.sources[i].sourceName;
							_currentRecord[sourceName] = RecordsUtil.getSecondaryRecord(item,sourceName);
						}
						gi.selectedRecords.push(_currentRecord);
					}
				}
			}
			else
			{
				var _selectedRecords = [];
				CommandActions.getSelectRecords(_selectedRecords,_group.groupAlias,formModule.instanceUUId);
				let _remoteClassRecords = [];
				for(let i=0;i<_selectedRecords.length;i++)
				{
					let _record = _selectedRecords[i];
					if(!_record)continue;
					let _currentRecord = {remoteClass:"java.util.HashMap"};
					
					for(let i = 0;i<_group.sources.length;i++)
					{
						var sourceName = _group.sources[i].sourceName;
						let secondRec = RecordsUtil.getSecondaryRecord(_record,sourceName);
						_currentRecord[sourceName] = secondRec;
					}
					_remoteClassRecords.push(_currentRecord);
				}
				
				gi.selectedRecords = _remoteClassRecords;//.length==0?null:_remoteClassRecords;
			}

		}
		
		
		if(allRecords)
		{
			let _remoteClassRecords = [];
			if(_group.records)
			{
				for(let key in _group.records)
				{
					let _record = _group.records[key];
					let _currentRecord = {remoteClass:"java.util.HashMap"};
			
					for(let i = 0;i<_group.sources.length;i++)
					{
						var sourceName = _group.sources[i].sourceName;
						_currentRecord[sourceName] = RecordsUtil.getSecondaryRecord(_record,sourceName);
					}

					_remoteClassRecords.push(_currentRecord);
				}
				
				gi.allRecords = _remoteClassRecords.length==0?null:_remoteClassRecords;	
			}
			else
			{
				gi.allRecords = null;
			}
		}
		
		if(currentQuery)
		{
			//alert("currentQuery  1");
			gi.currentQuery = _group.getCurrentQueryTable();
			if(gi.currentQuery)
			{
				//alert("currentQuery  2");
				gi.currentQuery.parentProperty = null;
				gi.currentQuery.queryRelations = null;
			}
		}
		
		if(formQuery)
		{
			gi.formQuery = QueryUtil.convertXML2QueryTable(_group.formQuery);
			if(gi.formQuery)
			{
				gi.formQuery.parentProperty = null;
				gi.formQuery.queryRelations = null;
			}
		}
		
		//TODOcalcHasColumnAsSysSelectRecords(gi, _group, formDesign);
	}

	static getSendCmd(formModule, defaultGroupAlias, argInfo,parms = {})
	{
		
		if(argInfo==null || (!parms.ignoreFetchOption && argInfo.fetchOption==false))
			return null;
		var arg = new CommandArg();
		
		arg.formParam = CommandResolver.getFormParam(formModule, defaultGroupAlias);
		arg.contextMap = formModule.contextMap;
		
		arg.argObject = null;	//在plugin二次开发时会传入plugin中指定的obj
		arg.defaultGroupAlias = defaultGroupAlias;
		
		arg.mapGroups = {};
		var _fds = formModule.formDataSources;

		var list;
		if(parms.ignoreFetchOption == true && argInfo.groups == null)
			argInfo.groups = "current(3)";
		if(argInfo.groups!=null)
		{
			var s = StringUtil.trimThrough(argInfo.groups);
			var _group;
			
			if(s.indexOf("current")==0)
			{
				if(_fds != null)
				{
					if(defaultGroupAlias!=null)
						_group = _fds.groups[defaultGroupAlias];
					if(_group==null)
						_group = _fds.firstGroup;
				}
			
				var num;

				if(_fds!=null)
				{
					if(s.indexOf("(") != -1)
					{
						num = s.substring(s.indexOf("(")+1,s.indexOf(")"));
						CommandResolver.numToReg(num,_group,formModule,arg,false);
					}
					else
					{
						CommandResolver.numToReg("2",_group,formModule,arg,false);
					}
				}
				
			}
			else if(s.indexOf("all") == 0)
			{
				if(formModule.formDataSources!=null)
				{
					for(var key in formModule.formDataSources.groups)
					{
						var _group = formModule.formDataSources.groups[key];
						if(s.indexOf("(") != -1)
						{
							num = s.substring(s.indexOf("(")+1,s.indexOf(")"));
							CommandResolver.numToReg(num,_group,formModule,arg,false);
						}
						else
						{
							CommandResolver.numToReg("2",_group,formModule,arg,false);
						}	
					}
				}
			}
			else if(s == "none")
			{
				arg.mapGroups = null;
			}
			else
			{
				if(formModule.formDataSources != null)
				{
					var groupAlias;
					if(s.indexOf("(") != -1)
					{
						num = s.substring(s.indexOf("(")+1,s.indexOf(")"));
						groupAlias = s.substring(0,s.indexOf("("));
					}
					else
					{
						num = "2";
						groupAlias = s;
					}
					
					if(formModule.formDataSources.groups != null)
						_group = formModule.formDataSources.groups[groupAlias];
					
					CommandResolver.numToReg(num,_group,formModule,arg,false);
				}
			}
		}
		
		if(argInfo.editors==null)
			list = [];
		else
			list = StringUtil.trimThrough(argInfo.editors).split(",");
		arg.mapEditors = {};
		for(var i=0;i<list.length;i++)
		{
			var s = list[i];
			if(s == "all")
			{
				CommandActions.commandArgMapEditors("all",arg.mapEditors,formModule.instanceUUId);
			}
			else if(s == "none")
			{
				arg.mapEditors = null;
			}
			else
			{
				if(s=="")//后台代码中有editor=""这种写法 会导致解析报错
					continue;
				CommandActions.commandArgMapEditors(s,arg.mapEditors,formModule.instanceUUId);
			}
		}
		
		s = argInfo.joinGroup;
		if(s!=null && s.indexOf("yes")==0)
		{
			var _argCaller = window.argCaller;
			if(_argCaller && _argCaller.joinGroupAlias!="" && _argCaller.joinGroupAlias)
			{
				var _parentWindow = window.parent.window;
				var _joinGroup = _parentWindow.getJoinGroupObject(_argCaller.joinGroupAlias,_argCaller.calleruuId)
				//var joinGroupObject = {groupAlias:_argCaller.joinGroupAlias,tableName:_argCaller.joinTableName,currentRecord:_argCaller.joinRecord};
				if(s.indexOf("(") != -1)
				{
					//不支持joinGroup的records及query
					num = s.substring(s.indexOf("(")+1,s.indexOf(")"));
					CommandResolver.numToReg("1",_joinGroup,formModule,arg,true);
				}
				else
				{
					CommandResolver.numToReg("1",_joinGroup,formModule,arg,true);
				}
			}
			else
			{
				if(defaultGroupAlias!=null && _fds)
					_group = _fds.groups[defaultGroupAlias];
				if(_group==null && _fds)
					_group = _fds.firstGroup;
				if(_group && _group.linkGroup)
				{
					if(s.indexOf("(") != -1)
					{
						num = s.substring(s.indexOf("(")+1,s.indexOf(")"));
						CommandResolver.numToReg(num,_group.linkGroup,formModule,arg,true);
					}
					else
					{
						CommandResolver.numToReg("1", _group.linkGroup,formModule,arg,true);
					}
				}
			}
		}
		return arg;
		
	}

	static getTaskGroup(task, fm)
	{
		if(task==null || fm==null || fm.formDataSources==null)
			return null;
		
		if(task.group!=null)
			var group = fm.formDataSources.groups[task.group];
		
		if(group==null)
			group = fm.formDataSources.firstGroup;
		
		return group;
		
	}

	static doResolveTask(task,formModule,tasks)
	{
		switch(task.cmd)
		{
			case Cmd.ExecuteQuery:
			{

				CommandResolver.doExecuteQuery(task.group,formModule,CommandResolver.getTaskGroup(task,formModule),tasks,task);
				
				return;
			}
			case Cmd.FadeInfo:
			{
				if(typeof(task.arg) == "string")
				{
					if(window.fadeInfo)
						window.fadeInfo({text:task.arg});
					else
						window.parent.window.fadeInfo({text:task.arg})
				}
				else if(typeof(task.arg) == "object")
				{
					task.arg.backgroundColor = task.arg.bgColor;task.arg.text = task.arg.label;task.arg.color = task.arg.labelColor;
					if(window.fadeInfo)
						window.fadeInfo({text:task.arg});
					else
						window.parent.window.fadeInfo(task.arg)
				}
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.UpdateControlAllowEdit :
			{
				CommandResolver.updateControlAllowEdit(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.UpdateControlVisible:
			{
				CommandResolver.updateControlVisible(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;	
			}
			case Cmd.UpdateControlLabel:
			{
				CommandResolver.updateControlLabel(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.UpdateControlShowDecimal:
				{
					CommandResolver.updateControlShowDecimal(task,formModule);
					let task2 = tasks.shift();
					if(task2)
					   CommandResolver.doResolveTask(task2,formModule,tasks);
					return;
			}
			case Cmd.UpdateControlSkipTab:
			{
				CommandResolver.updateControlSkipTab(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case "lookupRefresh":		//服务端CommandTaskCMD中不需要出现，所以写死字符串
			{
				CommandResolver.doLookupRefresh(task, formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.LookupReturn:
			{
				CommandResolver.lookupReturn(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.UpdateEditorShowLookup:
			{
				CommandResolver.updateEditorShowLookup(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.FormCmd:
			{
				CommandResolver.formCmd(task,formModule,tasks);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.UpdateQueryForm :
			{
				CommandResolver.changeQuery(task,CommandResolver.getTaskGroup(task, formModule),formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.UpdateQueryCurrent :
			{
				CommandResolver.changeQuery(task,CommandResolver.getTaskGroup(task, formModule),formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.UpdateQuery:
			{
				CommandResolver.changeQuery(task,CommandResolver.getTaskGroup(task, formModule),formModule);
				CommandResolver.doExecuteQuery(task.group,formModule,CommandResolver.getTaskGroup(task,formModule),tasks,task);
				return;
			}
			case Cmd.RefreshPlugin:
			{
				CommandResolver.doRefreshPlugin(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.TmpRecordAdd:
			{
				CommandResolver.addTempRecord(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.TmpRecordClear:
			{
				CommandResolver.clearTempRecord(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.TmpRecordRefresh:
			{
				CommandResolver.refreshTempRecord(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.WriteEditor:
			case Cmd.WriteImage:
			{
				CommandResolver.writeControl(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.DoWriteEditor:
			{
				CommandResolver.doWriteControl(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.ButtonOk:
			{
				window.remainTasks = tasks;
				CommandResolver.doRemoteButtonOk(task, formModule);
				return;
			}
			case Cmd.OpenForm:
			case Cmd.OpenMainForm:
			{
				CommandResolver.openForm(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.OpenSubForm:
			{
				CommandResolver.openSubForm(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.RestoreParent:
			{
				let _result = CommandResolver.restoreParent(task,formModule,tasks);
				if(!_result)
				{
					let task2 = tasks.shift();
				    if(task2)
				       CommandResolver.doResolveTask(task2,formModule,tasks);
				}
				return;
			}
			case Cmd.ParentCmdResult:
			{
				CommandResolver.exeParentCmdResult(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.OpenResource:
			{
				let _url = task.arg;
				if(_url)
				{
					_url = CommonUtil.calcResourcePath(_url);
					let n = _url.length>20?_url.substr(0,20):_url;

					window.open(_url,n);
					
				}
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.OpenURL :	//TODO 打开相对于客户端html的一个网页，或者全路径，  待修正 
			{
				let openurlarg = task.arg;
				if(!openurlarg)Warning.show({text:"OpenURL命令的参数为空"});
				let _url = openurlarg.url;
				if(!_url)Warning.show({text:"OpenURL命令没有给出一个有效的URL"});
				if(!(_url.indexOf("http://")==0 || _url.indexOf("https://")==0))
				{
					_url = "html/" + _url;
				}
				FormLoadHelper.openHtml(_url,!openurlarg.parameters?"":openurlarg.parameters);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}	
			case Cmd.RecordRestore:
			{
				window.remainTasks = tasks;
				CommandResolver.doRecordRestore(task,formModule);
				return;
			}
			case Cmd.DS_AllowAdd:
			{
				CommandResolver.doDsAllowAdd(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.DS_AllowAttachment:
			{
				CommandResolver.doDsAllowAttachment(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.DS_AllowDelete:
			{
				CommandResolver.doDsAllowDelete(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.DS_AllowExport:
			{
				CommandResolver.doDsAllowExport(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.DS_AllowQuery:
			case Cmd.DS_AllowChangeQuery:
			{
				CommandResolver.doDsAllowQuery(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.DS_AllowSave:
			{
				CommandResolver.doDsAllowSave(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.DS_AllowEdit:
			{
				CommandResolver.doDsAllowEdit(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			/*case Cmd.CloseForm:
			{
				window.parent.window.closeForm(window.formModuleInstanceuuId,true)
				return;
			}
			case Cmd.DoCloseForm:
			{
				if(window.isPopUp)
					window.parent.window.closePopUpForm();
				else
					window.parent.window.closeForm(window.formModuleInstanceuuId)
				return;
			}*/
			case Cmd.SwitchToTabPage:
			{
				CommandResolver.changeTabPage(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.FocusIn:
			{
				CommandResolver.setControlFocus(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.BindRowStyle:
			{
				CommandResolver.setControlStyle(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.BindEditorStyle:
			{
				CommandResolver.setControlStyle(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.SetButtonStyle:
			{
				CommandResolver.setButtonStyle(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.SetTextStyle:
			{
				CommandResolver.setTextStyle(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.SetContainerStyle:
			{
				CommandResolver.setContainerStyle(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.SetRecordConditionTask:
			{
				CommandResolver.doRecordConditionTask(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.SetFormParamConditionTask:	//TODO 参照上面Cmd.RecordConditionTasks改造
			{
				CommandResolver.doFormParamConditionTasks(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.ContextMap:
			{
				CommandResolver.doFormContext(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.ShowDialog:
			{
				CommandResolver.showDialog(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.Alert:
			{
				var defaults = {
					state:"warn",
				 	backgroundColor:undefined,
				 	color:"#fff",
				 	text:task.arg,
				 	cornerRadius:"10",
				 	interacdestroy:true,
				 	cancel:{
				 		isShow:false,
				 		event:''
				 	}
				};
				if(window.parent.window && window.parent.window.showWarn)
					window.parent.window.showWarn(defaults);
				else
					Warning.show(defaults);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.Js :
			{
				let js = task.arg;
				eval(js);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.FileDownload:
			{
				CommandResolver.downLoad(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.FileUploadCmd:
			{
				CommandResolver.fileUpload(task,formModule,tasks);
				return;
			}
			case Cmd.CreateTimer:
			{
				CommandResolver.addTimer(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.CancelTimer:
			{
				CommandResolver.cancelTimer(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.SetFormTitle:
			{
				CommandResolver.doSetFormTitle(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.SetControlProperty:
			{
				CommandResolver.doSetControlProperty(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.ClientRecordRemove:
			{
				CommandResolver.doClientRecordRemove(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.DimSortFormItem:
			{
				CommandResolver.doSortComponent(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.SortFormItem:
			{
				CommandResolver.doSortFormItem(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.DimAdjustFormDataSourceField:
			{
				CommandResolver.doDimAdjustFormDataSourceField(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.CloseForm:
			{
				if(window.isPopUp)
					window.parent.window.closePopUpFormByUUId(window.formModuleInstanceuuId,true);
				else
					window.parent.window.closeForm(window.formModuleInstanceuuId,true)
				return;
			}
			case Cmd.DoCloseForm:
			{
				if(window.isPopUp)
					window.parent.window.closePopUpFormByUUId(window.formModuleInstanceuuId,false);
				else
					window.parent.window.closeForm(window.formModuleInstanceuuId,false)
				return;
			}
			case Cmd.ShowInfo:
			{
				CommandResolver.doShowInfo(task);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.TmpRecordDelete:
			{
				CommandResolver.deleteTempRecord(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.ActiveRecord:
			{
				CommandResolver.activeRecord(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.UpdateToolBar:
			{
				CommandResolver.updateToolBar(task,formModule);
				let task2 = tasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.LocateToRecord:
			{
				CommandResolver.doLocateToRecord(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.LocateRecord:
			{
				CommandResolver.doLocateRecord(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.RecordNew:
			{
				CommandResolver.doRecordNew(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.RecordDelete:
			{
				CommandResolver.doRecordDelete(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.RecordSave:
			{
				CommandResolver.doRecordSave(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.ClientRecordRefresh:
			{
				CommandResolver.doClientRecordRefresh(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.ClientRecordAdd:
			{
				CommandResolver.doClientRecordAdd(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.UpdateGroupCollapseState:
			{
				CommandResolver.doUpdateGroupCollapseState(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.WriteField:
			{
				CommandResolver.writeField(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.DoWriteField:
			{
				CommandResolver.doWriteField(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.HoldFocusIn:
			{
				CommandResolver.holdFocusIn(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.RegisterRender:
			{
				CommandResolver.registerRender(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.DragStart:
			{
				CommandResolver.dragStart(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.ShowCalculator:
			{
				CommandResolver.showCalculator(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.UpdateDropDownContent:
			{
				CommandResolver.updateDropDownContent(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.SysReinitForm:
			{
				CommandResolver.doSysReinitForm(task,formModule,tasks);
				return;
			}
			case Cmd.ShowClipboard:
			{
				CommandResolver.showClipboard(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.ShowImage:
			{
				CommandResolver.showImage(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.FetchAll:
			{
				CommandResolver.doFetchAll(task,formModule,tasks);
				return;
			}
			case Cmd.WriteDataMethodField:
			{
				CommandResolver.doWriteDataMethodField(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.CallClientMethod:
			{
				CommandResolver.CallClientMethod(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.SelectRecords:
			{
				CommandResolver.clientSelectRecords(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.Ds_AttachmentAllowDelete:
			{
				CommandResolver.dsAttachmentAllowDelete(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.Ds_AttachmentAllowRename:
			{
				CommandResolver.dsAttachmentAllowRename(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.Ds_AttachmentAllowUpload:
			{
				CommandResolver.dsAttachmentAllowUpload(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.Ds_AttachmentAllowVisible:
			{
				CommandResolver.dsAttachmentAllowVisible(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.OpenLuckySheet:
			{
				CommandResolver.doOpenLuckySheet(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.UpdateAllowEditorNotSelectAll:
			{
				CommandResolver.doUpdateAllowEditorNotSelectAll(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			case Cmd.PrintReport:
			{
				CommandResolver.doPrintReport(task,formModule);
				let task2 = tasks.shift();
				if(task2)
					CommandResolver.doResolveTask(task2,formModule,tasks);
				return;
			}
			default :
			{
				alert("未能解析的指令:" + task.cmd);
				return;
			}
		}
	}

	static resolve(tasks,formModule,group=null)
	{
		if(!tasks || !Array.isArray(tasks))
			return;
		tasks = tasks.concat();
		let closeFormIndex = -1;
		for(let i = 0;i<tasks.length;i++)
		{
			let task = tasks[i];
			if(!task)continue;
			if(task.group==null)
			{
				task.group = group==null?null:group.groupAlias;
				if(task.group==null && formModule)
				{
					var _fds = formModule.formDataSources;
					if(_fds && _fds.firstGroup)
						task.group = _fds.firstGroup.groupAlias;
				}
			}
			if(task.cmd == Cmd.CloseForm || task.cmd == Cmd.DoCloseForm)
				closeFormIndex = i;
		}

		//TODO 为了防止closeForm命令卸载程序而导致某些代码无法执行 暂时把命令中的closeForm放置最后执行
		//比如 原来有大量的 closeForm->parentCommandResult命令组合 这在多页面应用程序中不好支持
		
		if(closeFormIndex != -1)
		{
			let deleteArr = tasks.splice(closeFormIndex,1);
			if(deleteArr.length>0)
				tasks.push(deleteArr[0]);
		}
		let oldTasks= JSON.stringify(tasks);
		let task = tasks.shift();
		if(task)
			CommandResolver.doResolveTask(task,formModule,tasks);
		
		if(oldTasks){
			let oldts = JSON.parse(oldTasks)
			let needRefFildGroup =[];
			let cdmCom;
			for(let i = 0;i<oldts.length;i++)
			{
				let task = oldts[i];
				if(!task)continue;
				if(task.cmd =="updateControlVisible"){
					if(task.control)
					{
						var isLookup = (formModule.classAlias == "FormModuleLookup");
						var keyBase = formModule.menuItemId+"."+formModule.formId+".";
						var itemControl = FormItemUtil.getFormItemControl(keyBase+task.control,isLookup);
						if(itemControl)
						{
							if(itemControl.parentControl &&itemControl.parentControl.classAlias=="FormItemFieldGroupControl"){
								// ResizeActions.groupRefersh(task.control);
								if(needRefFildGroup.length == 0){
									needRefFildGroup.push(itemControl.parentControl.innerId);
								}else{
									if(needRefFildGroup.indexOf(itemControl.parentControl.innerId) == -1){
										needRefFildGroup.push(itemControl.parentControl.innerId);
									}
								}
							}
						}
					}
				}
			}
			for(let i in needRefFildGroup){
				let innerId = needRefFildGroup[i];
				let arg={innerId:innerId,formId:formModule.formId};
				ResizeActions.groupRefersh(arg);
			}
		}
	}

	static fileUpload(task,formModule,tasks)
	{
		let arg = {
			state:"info",
		 	text:"确认要上传文件",
		 	confirm:{
		 		isShow:true,
		 		event:function(e)
		 		{
		 			CommandResolver.doFileUpload(task,formModule,tasks);
		 		}
		 	},
		 	cancel:{
		 		isShow:true,
		 		event:''
		 	}

		};
		if(task.arg && task.arg.title)
			arg.title = task.arg.title;
		if(task.arg && task.arg.info)
			arg.text = task.arg.info;
		Warning.show(arg);
	}

	static doFileUpload(task,formModule,laterTasks)
	{
		let fileUploadArg = task.arg;
		if(!fileUploadArg.url)fileUploadArg.url = "";
		fileUploadArg.url = window.parent.window.userInfos.serviceURL+"/FileUpLoad?path="+fileUploadArg.url;

		$("#commonFileInput").off("change").on("change",function(event){
		  	CommandResolver.fieldUploadFileSelected(event,fileUploadArg,laterTasks,formModule);
		});

		if(fileUploadArg.type)$("#commonFileInput").attr("accept",fileUploadArg.type);
		else $("#commonFileInput").attr("accept","*");

		$("#commonFileInput").click();
	}
	

	static tmpXMLHttpRequest = null;
	//只给后台fileUpload上传命令使用 License的上传功能在LicenseUpLoad中 不调用该方法
	static fieldUploadFileSelected(e,fileUploadArg,laterTasks,formModule)
	{
		var uploadFiles = e.target.files || e.dataTransfer.files;
		var uploadFile = uploadFiles[0];
		
		if(fileUploadArg.maxSize && uploadFile.size > fileUploadArg.maxSize)
		{
			Warning.show({text:fileUploadArg.sizeLimitInfo});
			return;
		}

		/*if(Array.isArray(fileUploadArg.types) && fileUploadArg.types.indexOf(uploadFile.type) == -1)
		{
			Warning.show({text:fileUploadArg.typeLimitInfo});
			return;
		}*/

        let url = fileUploadArg.url;
		url = encodeURI(url);
		/*var domain = window.didomain;
		try//zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
		{
			if(!domain && window.parent && window.parent.window)
				domain = window.parent.window.didomain;

			if(domain)
			{
				url+=("&token="+localStorage.getItem("userToken"));
			}
				
		}
		catch(e)
		{
			
		}*/
        var oMyForm = new FormData();    
        oMyForm.append("file", uploadFile);
        
        var progressBar=$('<progress></progress>').css({'width':'15em','height':'2.1em'}).html('您的浏览器不支持progress元素');
        
        var progressA=$('<a></a>').css({'background-color':'#fff','color':'#ff0000','font-size':'1.5em'}).click(function(){that.client.abort()}).append("<i class='fa fa-times-circle' aria-hidden='true'></i>");
        var progressBtn=$('<div></div>').append(progressA);
        var progressDiv=$('<div></div>').css({'position':'absolute','top':'40.5%','left':'40%','display':'flex'}).append(progressBar).append(progressBtn);
        var percentageDiv=$('<span></span>');
        var time=$("<span></span>");
        var percentDiv=$('<div></div>').css({'position':'absolute','top':'41%','left':'40.5%','font-size':'0.8em'}).append(percentageDiv).append(time);
        var progressBorder=$("<div></div>").append(progressDiv).append(percentDiv).attr('id','progressBorder').addClass('modal');
        $('body').append(progressBorder);
        
        if(CommandResolver.tmpXMLHttpRequest == null)
        {
        	CommandResolver.tmpXMLHttpRequest=new XMLHttpRequest();
        }

    	CommandResolver.tmpXMLHttpRequest.upload.onprogress = function(pe) {
	        if(pe.lengthComputable) {
	        	progressBorder.css('display','block');
	         	progressBar.attr('max',pe.total);
	        	progressBar.attr('value',pe.loaded);
	         	percentageDiv.html(Math.round(pe.loaded / pe.total * 100) + "%");
	        }
	        var nt = new Date().getTime();//获取当前时间
	        var pertime = (nt-this.ot)/1000; //计算出上次调用该方法时到现在的时间差，单位为s
	        this.ot = new Date().getTime(); //重新赋值时间，用于下次计算
	        var perload = pe.loaded - this.oloaded; //计算该分段上传的文件大小，单位b       
	        this.oloaded = pe.loaded;//重新赋值已上传文件大小，用以下次计算
	                    
	        //上传速度计算
	        var speed = perload/pertime;//单位b/s
	        var bspeed = speed;
	        var units = 'b/s';//单位名称
	        if(speed/1024>1){
	            speed = speed/1024;
	            units = 'k/s';
	        }
	        if(speed/1024>1){
	            speed = speed/1024;
	            units = 'M/s';
	        }
	        speed = speed.toFixed(1);
                        //剩余时间
        	var resttime = ((pe.total-pe.loaded)/bspeed).toFixed(1);
	        
	        var timeContent=' '+speed+units+'，剩余时间：'+resttime+'s';
	        time.html(timeContent); 
    	}

	    CommandResolver.tmpXMLHttpRequest.upload.onloadstart = function(){//上传开始执行方法
	        this.ot = new Date().getTime();   //设置上传开始时间
	        this.oloaded = 0;//设置上传开始时，以上传的文件大小为0
	    };
	    CommandResolver.tmpXMLHttpRequest.onreadystatechange=function(){
			if (CommandResolver.tmpXMLHttpRequest.readyState==4)
		    {
		  		if(CommandResolver.tmpXMLHttpRequest.status==200)
		    	{	
		    		let options={state:'success',text:'上传成功！'};Fade.show(options);	
		    	}
			  	else
			    {
			    	let options={state:'error',text:'上传失败！'};Fade.show(options);
			    }
				$('#commonFileInput').val('');
				
				if(fileUploadArg && fileUploadArg.callBack)
				{
					let arg = {};
					arg["methodName"] = fileUploadArg.callBack;
					let callBackArg = {remoteClass:"java.util.Map"};
					if(uploadFile)
					{
						callBackArg.name = uploadFile.name;
						callBackArg.lastModified = uploadFile.lastModified;
						callBackArg.size = uploadFile.size;
						callBackArg.type = uploadFile.type;
						callBackArg.webkitRelativePath = uploadFile.webkitRelativePath;
					}

					arg["methodArg"] = callBackArg;
						
					var commandTask = new CommandTask();
					commandTask.cmd = Cmd.FormCmd;
					commandTask.arg = arg;
					CommandResolver.formCmd(commandTask,formModule);
				}

	        	let task2 = laterTasks.shift();
			    if(task2)
			       CommandResolver.doResolveTask(task2,formModule,laterTasks);
		  	}	

		};
		CommandResolver.tmpXMLHttpRequest.onloadend = function(pe)
	    {
	    	//alert("end");
	        $('#progressBorder').remove();
	    }
        
            
	    CommandResolver.tmpXMLHttpRequest.open("POST", url,false);//+'FileUpLoad?cid=F166E032-841D-2E93-C00A-309A1C38563A
	    CommandResolver.tmpXMLHttpRequest.withCredentials = true;
	               
	    CommandResolver.tmpXMLHttpRequest.send(oMyForm);
	}

	static calcResourcePath(url)
	{
		var _url;
		if(url.substr(0, 5)=="@tmp/")
		{
			
			_url = window.parent.window.userInfos.serviceURL + "/tmp/" + url.substr(5);
		}
		else
		{
			_url = window.parent.window.userInfos.resourceURL + "/" + url;
		}
		
		return _url;
	}

	static downLoad(task,formModule)
	{
		let url;let fname;
		if(typeof(task.arg) == "string")
		{
			url = task.arg;
			if(!url)
			{
				alert("未填写下载路径");
				return;
			}
			fname = url.substr(url.lastIndexOf("/")+1);
		}
		else if(typeof(task.arg) == "object")
		{
			url = task.arg.url;
			if(!url)
			{
				alert("未填写下载路径");
				return;
			}
			fname = task.arg.defaultName?task.arg.defaultName:url.substr(url.lastIndexOf("/")+1);
		}
		
		url = CommandResolver.calcResourcePath(url);



		/*var blob=new Blob([''], {type:'application/octet-stream'});
	    var urlobj = URL.createObjectURL(blob);
	    var a = document.createElementNS('http://www.w3.org/1999/xhtml','a');
	    a.href = url;
	    a.download = fname; 
	    var e = document.createEvent('MouseEvents');
	    e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	    a.dispatchEvent(e);
	    URL.revokeObjectURL(urlobj);*/
		/*window.didomain = "OA";
		if(window.didomain)
		{
			fetch(url, {
				method: 'GET',
				headers: new Headers({
				  'token':localStorage.getItem("userToken")
				})
			  })
				.then(res => res.blob())
				.then(data => {
				  const blobUrl = window.URL.createObjectURL(data);
				  CommandResolver.adownload(blobUrl);
			});
		}
		else
		{
			CommandResolver.adownload(url);
		}*/

		var domain = window.didomain;
		try//zsg 为了适应任务系统 框架页面和操作系统页面是跨域的 index.html打开时会报错 而form.html不会
		{
			if(!domain && window.parent && window.parent.window)
				domain = window.parent.window.didomain;

			if(domain)
			{
				var loginToken = window.loginToken;
	  			var loginDataArea = window.loginDataArea;
				if(window.parent && window.parent.window)
				{
					if(!loginToken)loginToken = window.parent.window.loginToken;
					if(!loginDataArea)loginDataArea = window.parent.window.loginDataArea;
				}
				if(!loginToken)
					url+=("?token="+localStorage.getItem("userToken"));
			}
				
		}
		catch(e)
		{
			
		}

		var a = document.createElementNS('http://www.w3.org/1999/xhtml','a');
		a.href = url;
		a.download = fname;
	
		var e = document.createEvent('MouseEvents');
		e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		a.dispatchEvent(e);
	}

	static adownload(url)
	{
		var a = document.createElementNS('http://www.w3.org/1999/xhtml','a');
		a.href = url;
		a.download = fname;
	
		var e = document.createEvent('MouseEvents');
		e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		a.dispatchEvent(e);
	}

	static setControlStyle(task,formModule)
	{
		let isLookup = (formModule.classAlias == "FormModuleLookup");
		let keyBase = formModule.menuItemId+"."+formModule.formId+".";
		let itemControl = FormItemUtil.getFormItemControl(keyBase+task.control,isLookup);
		if(itemControl)
		{
			let innerId = itemControl.xml.id;
			FormItemUtil.setControlStyles(isLookup?"FormLookup":window.menuItemId,formModule.formId,innerId,task.arg);
			CmdTypeActions.bindStyle(formModule.formId,task.control);
		}
	}

	static setButtonStyle(task,formModule)
	{
		let isLookup = (formModule.classAlias == "FormModuleLookup");
		let keyBase = formModule.menuItemId+"."+formModule.formId+".";
		let itemControl = FormItemUtil.getFormItemControl(keyBase+task.control,isLookup);
		if(itemControl)
		{
			let innerId = itemControl.xml.id;
			let _style = task.arg.map;
			if(_style.color && _style.color != -1)_style.color = "#"+_style.color.toString(16);
			if(_style.backgroundColor && _style.backgroundColor != -1) _style.backgroundColor = "#"+_style.backgroundColor.toString(16);
			FormItemUtil.setControlStyles(isLookup?"FormLookup":window.menuItemId,formModule.formId,innerId,_style);
			CmdTypeActions.setButtonStyle(formModule.formId,task.control);
		}
	}

	static setTextStyle(task,formModule)
	{
		let isLookup = (formModule.classAlias == "FormModuleLookup");
		let keyBase = formModule.menuItemId+"."+formModule.formId+".";
		let itemControl = FormItemUtil.getFormItemControl(keyBase+task.control,isLookup);
		if(itemControl)
		{
			let innerId = itemControl.xml.id;
			let _style = task.arg.map;
			if(_style.color && typeof(_style.color)!="string" && _style.color != -1)_style.color = "#"+_style.color.toString(16);
			if(_style.backgroundColor && _style.backgroundColor != -1) _style.backgroundColor = "#"+_style.backgroundColor.toString(16);
			FormItemUtil.setControlNoBindStyle(isLookup?"FormLookup":window.menuItemId,formModule.formId,innerId,_style);
			
			CmdTypeActions.setTextStyle(formModule.formId,task.control);
		}
	}

	static setContainerStyle(task,formModule)
	{
		let isLookup = (formModule.classAlias == "FormModuleLookup");
		let keyBase = formModule.menuItemId+"."+formModule.formId+".";
		let itemControl = FormItemUtil.getFormItemControl(keyBase+task.control,isLookup);
		if(itemControl)
		{
			let innerId = itemControl.xml.id;
			let _style = task.arg.map;
			FormItemUtil.setControlNoBindStyle(isLookup?"FormLookup":window.menuItemId,formModule.formId,innerId,_style);
			
			CmdTypeActions.setContainerStyle(formModule.formId,task.control);
		}
	}

	static openSubForm(task,formModule)
	{
		if(typeof(task.arg)=="string")
		{
			FormLoadHelper.openFormDirectly({formId:task.arg});
		}
		else if(task.arg)
		{
			var ofa = task.arg;
			var fm = formModule;
			var group;
		
			var addJoin = true;
			var _autoJoinParentArg = {autoJoinParent:true};
			if(ofa.addFixedGroupRelation==true && fm)
			{
				if(fm.formDataSources && fm.formDataSources.groups.hasOwnProperty(ofa.linkGroupAlias))
				{
					group = fm.formDataSources.groups[ofa.linkGroupAlias];
					_autoJoinParentArg.autoJoinParent = false;
					_autoJoinParentArg.autoJoinParentAlias = ofa.linkGroupAlias;
				}
			}
			else if(ofa.addAutoGroupRelation == true && fm)
			{
				group = CommandResolver.getTaskGroup(task,fm);
			}
			else
			{
				addJoin = false;
			}
			
		
			var ofa_paramObject = ofa.paramObject;
			if(typeof(ofa_paramObject)=="object" && ofa_paramObject && !ofa_paramObject.hasOwnProperty("remoteClass"))
				ofa_paramObject = Object.assign({remoteClass:"java.util.Map"},ofa_paramObject);
				
			FormLoadHelper.openFormDirectly({formId:ofa.subFormId,menuItemId:"-1",parm:ofa.paramString,fm:fm, 
				group:group,callerKey:ofa.callerKey,paramObject:ofa_paramObject,popUp:ofa.isPopUp,addJoin:addJoin,
				autoJoinParentArg:_autoJoinParentArg,ingnoreAu:ofa.ingnoreAu
			});
		}
	}

	static openForm(task,formModule)
	{
		if(typeof(task.arg)=="string")
		{
			FormLoadHelper.openMenuItemByAuthority({menuItemId:task.arg});
		}
		else if(task.arg)
		{
			var ofa = task.arg;//ofa.addAutoGroupRelation = true;
			var fm = formModule;
			var group;
			var serverSepcLinkType = "";
			var addJoin = true;
			var _autoJoinParentArg = {autoJoinParent:true};
			if(ofa.addFixedGroupRelation==true && fm)
			{
				if(fm.formDataSources && fm.formDataSources.groups.hasOwnProperty(ofa.linkGroupAlias))
				{
					group = fm.formDataSources.groups[ofa.linkGroupAlias];
					_autoJoinParentArg.autoJoinParent = false;
					_autoJoinParentArg.autoJoinParentAlias = ofa.linkGroupAlias;
				}
			}
			else if(ofa.addAutoGroupRelation == true && fm)
			{
				group = CommandResolver.getTaskGroup(task,fm);
			}
			else
			{
				addJoin = false;
			}
			
			var mainTableWhereValues;
			var ofa_paramObject = ofa.paramObject;
			if(typeof(ofa_paramObject)=="object" && ofa_paramObject && !ofa_paramObject.hasOwnProperty("remoteClass"))
				ofa_paramObject = Object.assign({remoteClass:"java.util.Map"},ofa_paramObject);
				
			FormLoadHelper.openMenuItemByAuthority({menuItemId:ofa.menuItemId,parm:ofa.paramString,fm:fm, 
				group:group,callerKey:ofa.callerKey,paramObject:ofa_paramObject,popUp:ofa.isPopUp,addJoin:addJoin,
				autoJoinParentArg:_autoJoinParentArg,ingnoreAu:ofa.ingnoreAu,commandArgInfo:ofa.commandArgInfo
			});
		}
		// else if(task.arg is OpenMainFormArg)
		// {
			
		// 	fm = formDesign.formModule;
		// 	var mainFormArg:OpenMainFormArg = task.arg as OpenMainFormArg;
		// 	ofa = mainFormArg.switchToOpenFormArg();
		// 	FormLoadHelper.openMenuItemByAuthority(ofa.menuItemId, ofa.paramString, fm, null, ofa.mainFormWhereValues);
			
		// }
	}

	static updateEditorShowLookup(task,formModule)
	{
		var _key = FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,task.control);
		if(task.control)
		{
			var control = FormItemUtil.getFormItemControl(_key);
			if(control)
			{
				control.serverHasLookup = task.arg;
			}
			
		}
		else
		{
			if(task.arg)
			{
				for(var key in task.arg)
				{
					if(typeof(task.arg[key]) == "boolean")
					{
						var lookupVisible = task.arg[key];
						var control = FormItemUtil.getFormItemControl(_key);
						if(control.classAlias == "FormItemStringEditorControl")
							control.serverHasLookup = lookupVisible;
					}
					
				}
			}
		}
	}

	static doFetchAll(task,formModule,tasks)
	{
		var _group = CommandResolver.getTaskGroup(task, formModule);
		if(_group)
		{
			_group.recordFetchAllForCmd(tasks);
		}
		else
		{
			if(tasks)
			{
				let _task = tasks.shift();
				if(task)
					CommandResolver.doResolveTask(_task,formModule,tasks);
			}
		}
	}

	static doExecuteQuery(groupAlias, formModule, group, tasks,task)
	{
		if(formModule.formDataSources==null)
			return false;
		
		var _group;let executed = false;
		var sync = false;
		if(task.arg && task.arg.hasOwnProperty("sync"))
			sync = task.arg.sync;
		if(groupAlias==null)
		{
			if(group!=null)
			{
				group.reExecuteQuery(sync,tasks);executed = true;
			}
				
		}
		else if(groupAlias=="all")
		{
			var flag = false;
			for(var key in formModule.formDataSources.groups)
			{
				var _group = formModule.formDataSources.groups[key];
				if(_group.linkGroup==null || _group.linkGroup.formDataSources!=group.formDataSources)
				{
					_group.reExecuteQuery(sync,tasks);executed = true;
				}
			}
		}
		else
		{
			_group = formModule.formDataSources.groups[groupAlias];
			if(_group!=null)
			{
				_group.reExecuteQuery(sync,tasks);executed = true;
			}
				
		}

		if(executed == false)
			if(tasks)
			{
				let task = tasks.shift();
				if(task)
					CommandResolver.doResolveTask(task,formModule,tasks);
			}
	}

	static updateControlVisible(task,formModule)
	{
		var isLookup = (formModule.classAlias == "FormModuleLookup");
		var keyBase = formModule.menuItemId+"."+formModule.formId+".";
		if(task.control)
		{
			var itemControl = FormItemUtil.getFormItemControl(keyBase+task.control,isLookup);
			if(itemControl)
			{
				itemControl._cmdVisibleFalse = !task.arg;
				//if(itemControl.finalVisibleInited == true)
				//	itemControl.finalVisibleInited = false;
				//TODO_YL 临时修改 当Editor 存在DATAGrid里面的时候 隐藏失效
				if(itemControl.parentXML && itemControl.parentXML.type == "DataGrid" && itemControl.dataField){
					task.control = itemControl.dataField.substring(0,itemControl.dataField.lastIndexOf("."))+"_"+StringUtil.convertToFirstUpperCase(itemControl.dataField.substring(itemControl.dataField.lastIndexOf(".")+1))
				}
				CmdTypeActions.updateControlVisible(formModule.menuItemId,formModule.formId,[task.control],isLookup);
			}
				
		}
		else
		{
			if(task.arg)
			{
				var controlNames = [];
				for(var key in task.arg)
				{
					if(typeof(task.arg[key])=="boolean")
					{
						var allowEdit = task.arg[key];
						var itemControl = FormItemUtil.getFormItemControl(keyBase+key,isLookup);
						if(itemControl)
						{
							itemControl._cmdVisibleFalse = !allowEdit;
							//if(itemControl.finalVisibleInited == true)
							//	itemControl.finalVisibleInited = false;
						if(itemControl.componentDim){
							controlNames.push(key);
						}else{
												//TODO_YL 临时修改 当Editor 存在DATAGrid里面的时候 隐藏失效
							if(itemControl.parentXML && itemControl.parentXML.type == "DataGrid" && itemControl.dataField){
								key = itemControl.dataField.substring(0,itemControl.dataField.lastIndexOf("."))+"_"+StringUtil.convertToFirstUpperCase(itemControl.dataField.substring(itemControl.dataField.lastIndexOf(".")+1))
							}
								controlNames.push(key);
							}

						}
					}
				}
				CmdTypeActions.updateControlVisible(formModule.menuItemId,formModule.formId,controlNames,isLookup);
			}
		}
	}

	static updateControlSkipTab(task,formModule)
	{
		if(task.control)
		{
			var itemControl = FormItemUtil.getFormItemControl("ctrl_"+task.control,false);
			if(itemControl)
				itemControl.setControlSkipTabCmd(task.arg);
		}
		else
		{
			if(task.arg)
			{
				for(var key in task.arg)
				{
					if(typeof(task.arg[key])=="boolean")
					{
						var skipTab = task.arg[key];
						var itemControl = FormItemUtil.getFormItemControl("ctrl_"+key,false);
						if(itemControl)
						{
							itemControl.setControlSkipTabCmd(skipTab);
						}
						
					}
					
				}
			}
		}
	}

	static updateControlLabel(task,formModule)
	{
		if(task.control)
		{
			if(formModule&&formModule.classAlias=="FormModuleLookup"){
				var itemControl = FormItemUtil.getFormItemControl(formModule.menuItemId+"."+formModule.formId+"."+task.control,true);
				if(itemControl)
					itemControl.setControlLabelCmd(task.arg);
			}else{
				var itemControl = FormItemUtil.getFormItemControl("ctrl_"+task.control,false);
				if(itemControl)
					itemControl.setControlLabelCmd(task.arg);
			}
		}
		else
		{
			if(task.arg)
			{
				for(var key in task.arg)
				{
					
					var _label = task.arg[key];
					var itemControl = FormItemUtil.getFormItemControl("ctrl_"+key,false);
					if(itemControl)
					{
						itemControl.setControlLabelCmd(_label);
					}else{
						if(formModule&&formModule.classAlias=="FormModuleLookup"){
							itemControl = FormItemUtil.getFormItemControl(formModule.menuItemId+"."+formModule.formId+"."+key,true);
							if(itemControl)itemControl.setControlLabelCmd(_label);
						}
					}
				}
			}
		}
	}

	static updateControlShowDecimal(task,formModule)
	{
		if(task.control)
		{
			if(formModule&&formModule.classAlias=="FormModuleLookup"){
				var itemControl = FormItemUtil.getFormItemControl(formModule.menuItemId+"."+formModule.formId+"."+task.control,true);
				if(itemControl)
					itemControl.setControlShowDecimalCmd(task.arg);
			}else{
				var itemControl = FormItemUtil.getFormItemControl("ctrl_"+task.control,false);
				if(itemControl)
					itemControl.setControlShowDecimalCmd(task.arg);
			}
		}
		else
		{
			if(task.arg)
			{
				for(var key in task.arg)
				{
					
					var _value = task.arg[key];
					var itemControl = FormItemUtil.getFormItemControl("ctrl_"+key,false);
					if(itemControl)
					{
						itemControl.setControlShowDecimalCmd(_value);
					}else{
						if(formModule&&formModule.classAlias=="FormModuleLookup"){
							itemControl = FormItemUtil.getFormItemControl(formModule.menuItemId+"."+formModule.formId+"."+key,true);
							if(itemControl)itemControl.setControlShowDecimalCmd(_value);
						}
					}
				}
			}
		}
	}

	static updateControlAllowEdit(task,formModule)
	{
		if(task.control)
		{
			var itemControl = FormItemUtil.getFormItemControl("ctrl_"+task.control,false);
			if(itemControl)
				itemControl.doSetEnableCmd(task.arg);
			//CmdTypeActions.updateControlAllowEdit(_arg);
		}
		else
		{
			if(task.arg)
			{
				for(var key in task.arg)
				{
					if(typeof(task.arg[key])=="boolean")
					{
						var allowEdit = task.arg[key];
						var itemControl = FormItemUtil.getFormItemControl("ctrl_"+key,false);
						if(itemControl)
						{
							itemControl.doSetEnableCmd(allowEdit);
						}
						
					}
					
				}
				//CmdTypeActions.updateControlAllowEdit(task.arg);
			}
		}
	}

	static doWriteControl(task,formModule)
	{
		if(task.control)
		{
			var _arg = {};
			_arg[task.control] = task.arg;
			CmdTypeActions.writeControl(_arg,formModule.instanceUUId,false);
		}
		else
		{
			if(task.arg)
			{
				CmdTypeActions.writeControl(task.arg,formModule.instanceUUId,false);
			}
		}	
	}

	static writeControl(task,formModule)
	{
		if(task.control)
		{
			var _arg = {};
			_arg[task.control] = task.arg;
			CmdTypeActions.writeControl(_arg,formModule.instanceUUId,true);
		}
		else
		{
			if(task.arg)
			{
				CmdTypeActions.writeControl(task.arg,formModule.instanceUUId,true);
			}
		}
	}

	static doRemoteButtonOk(task,formModule)
	{
		if(task.control)
		{
			var _arg = {};
			_arg[task.control] = task.arg;
			CmdTypeActions.buttonOk(_arg);
		}
		else
		{
			if(task.arg)
			{
				CmdTypeActions.buttonOk(task.arg);
			}
		}
	}

	static doLookupRefresh(task,formModule)
	{
		var fm = formModule;
	    if(!fm || fm.classAlias != "FormModuleLookup") //当该form被直接拖到menuItem，作为独立窗口打开时
	    {
	    	alert("不能将标记为FormLookup的页面作为菜单项打开");
	    	return;
	    }
		fm.doLookupRefresh(task);
	}

	static lookupReturn(task,formModule)
	{
		
		//仅在自定义的下拉画面中有效，返回值回填到StringEditor
		//public CommandTask lookupReturn(String value)		
		
		//仅在自定义的下拉画面中有效，返回值按map中的key对应到dataField，按value回填值
		//当前单元格的字段会触发modifieldField_或者modifiedEditor_方法，其他字段不会触发
		//value需要统一转换成String
		//public CommandTask lookupReturn(Map<String, String> map)	
		
		
		//仅在自定义的下拉画面中有效，根据returnFields回填到主画面
		//当前单元格的字段会触发modifieldField_或者modifiedEditor_方法，其他字段不会触发
		//public CommandTask lookupReturn(List<FormLookupReturnField> returnFields) //仅在自定义的下拉画面中有效，根据returnFields回填到主画面，第1个字段会触发modifieldField_或者modifiedEditor_方法，从第2个字段起不会触发
		
		//TODO
		
		if(formModule.classAlias ==  "FormModuleLookup")
		{
			formModule.lookupReturnServer(task.arg);
		}
	}

	static formCmd(task,formModule,tasks)
	{
		var methodName;
		var methodArg;
		if(typeof(task.arg) == "string")
		{
			methodName = task.arg;
			methodArg = null;
		}
		else 
		{
			var obj = task.arg;
			methodName = obj["methodName"];
			methodArg = obj["methodArg"];
		}
		
		if(methodName.indexOf(".")!=-1)
			return;
		var isLookup = formModule.classAlias == "FormModuleLookup";
		var argInfo = FormResourceUtil.getCommandArgMethodInfo(methodName,isLookup?"FormLookup":formModule.menuItemId,formModule.props.formId);
		if(!argInfo)
			return;
		
		if(argInfo.prefetch==true)
		{
			if(!argInfo.commandResult)
				return;
			var newTasks = argInfo.commandResult.tasks; 
			CommandResolver.resolve(newTasks,formModule);
		}
		else
		{
			var _alias = null;
			var _group = CommandResolver.getTaskGroup(task, formModule);
			if(_group)
			{
				_alias = _group.groupAlias;
			}
			
			var cmdarg = CommandResolver.getSendCmd(formModule,_alias,argInfo);
			cmdarg.argObject = methodArg;
			var command = CommandHelper.createFormInstance(formModule.formName,methodName,"CommandResult");
			command.appendArg(cmdarg,"CommandArg");
			
			var _resultHandler = function(data)
			{
				var newCr = data.result;
				if(newCr && newCr.tasks && newCr.tasks.length>0)
				{
					var newTasks = newCr.tasks.reverse();
					if(!tasks)tasks = [];
					for(let i = 0;i<newTasks.length;i++)
					{
						tasks.unshift(newTasks[i]);
					}
				}
				if(tasks)var task = tasks.shift();
				if(task)
					CommandResolver.doResolveTask(task,formModule,tasks);
			};
			var remoteArg = {command:command,resultFunction:_resultHandler};
			if(!tasks || tasks.length == 0)
				remoteArg.sync = false;
			ServiceHelper.addTokenWithCommand(remoteArg);
			
		}
	}


	static changeQuery(task,group,formModule)
	{
		var queryTable = task.arg;
		if(!queryTable)
			return;
		var query ={
			nextInnerId:10000,qname:"Query",Properties:{
				Title:{V:""},Status:{V:"Open"},Literals:{V:"forcePlaceholders"},
				UseCache:{V:true},FetchType:{V:"List"},CreatedDate:{V:""},
				CreatedTime:{V:""},CreatedBy:{V:""},ModifiedDate:{V:""},
				ModifiedTime:{V:""},ModifiedBy:{V:""}
			}
		};
		var queryCopy = query;
		var targetGroup;
		
		if(group && group.groupAlias == queryTable.aliasName)
		{
			targetGroup = group;	
		}
		else
		{
			for(let _key in formModule.formDataSources.groups)
			{
				let item = formModule.formDataSources.groups[_key];
				if(item.groupAlias == queryTable.aliasName)
				{
					targetGroup = item;
					break;
				}
			}
		}
		
		if(!targetGroup)
		{
		
			return;
		}
		queryCopy.QueryTable = 
			QueryUtil.convertQueryTable2XML(queryTable,queryCopy);
		var targetQuery = queryCopy;
		var type = task.cmd;

		if(type == Cmd.UpdateQueryCurrent)
		{
			targetGroup.reSetCurrentQuery(targetQuery);
		}
		else if(type == Cmd.UpdateQueryForm)
		{
			targetGroup.formQuery = targetQuery;
		}
		else if(type == Cmd.UpdateQuery)
		{
			targetGroup.reSetCurrentQuery(targetQuery);
			targetGroup.formQuery = JSON.parse(JSON.stringify(targetQuery));
		}
	}
	
	static addTempRecord(task,formModule)
	{
		var ac = task.arg;
		var _group = CommandResolver.getTaskGroup(task, formModule);
		if(_group)
			_group.addTempRecords(ac);
	}

	static refreshTempRecord(task,formModule)
	{
		setTimeout(function()
		{
			var ac = task.arg;
			var _group = CommandResolver.getTaskGroup(task, formModule);
			if(_group)
			{
				_group.refreshTempRecordPartly(ac);
				/*if(task.control == "refreshPart")
				{
					_group.refreshTempRecordPartly(ac);
				}
				else
				{
					_group.refreshTempRecord(ac);
				}*/
			}
		},500);	
		
	}

	static clearTempRecord(task,formModule)
	{
		var _group = CommandResolver.getTaskGroup(task, formModule);
		if(_group)
			_group.clearTempRecord();
	}

	static doLocateToRecord(task,formModule)
	{
		var _group = CommandResolver.getTaskGroup(task,formModule);
		if(_group)
		{
			if(task.arg)
				_group.locateRecord(task.arg);
		}
	}

	static doLocateRecord(task,formModule)
	{
		var _group = CommandResolver.getTaskGroup(task,formModule);
		var type = task.arg;
		if(_group)
		{
			if(type == "NextPage")
				_group.recordNextPage(false,_group.groupAlias,_group.formDataSources.formModule.instanceUUId);
			else if(type == "PrevPage")
				_group.recordPrevPage(false,_group.groupAlias,_group.formDataSources.formModule.instanceUUId);
			else if(type == "Prev")
				_group.doRecordPrev();
			else if(type == "Next")
				_group.doRecordNext();
			else if(type == "First")
				_group.recordFirst(_group.groupAlias,_group.formDataSources.formModule.instanceUUId);
			else if(type == "Last")
				_group.recordLast(_group.groupAlias,_group.formDataSources.formModule.instanceUUId);
		}
	}

	static doRecordNew(task,formModule)
	{
		var _group = CommandResolver.getTaskGroup(task,formModule);
		if(_group)
			_group.doRecordNew();
	}

	static doRecordDelete(task,formModule)
	{
		var _group = CommandResolver.getTaskGroup(task,formModule);
		if(_group)
			_group.doRecordDelete(true,false);
	}

	static doRecordSave(task,formModule)
	{
		var _group = CommandResolver.getTaskGroup(task,formModule);
		if(_group)
			_group.doRecordSave(true);
	}

	static doClientRecordRefresh(task,formModule)
	{
		if(!task.arg)
			return;
		var _group = CommandResolver.getTaskGroup(task,formModule);
		if(_group)
			_group.doRefreshOnClient(task.arg);
	}

	static doUpdateGroupCollapseState(task,formModule)
	{
		if(task.control)
		{
			var _arg = {};
			_arg[task.control] = task.arg;
			CmdTypeActions.updateGroupCollapseState(_arg);
		}
		else
		{
			if(task.arg)
			{
				CmdTypeActions.updateGroupCollapseState(task.arg);
			}
		}
	}

	static exeParentCmdResult(task,formModule)
	{		
		var _parentWindow = window.parent.window;
		_parentWindow.exeParentCommandResult(argCaller.calleruuId,task.arg);
	}

	//TODO 目前一些需要远程的函数 都由命令调用 且目前全部为异步 其可以支持是否同步 命令在调用时应该做一些判断 尽量异步 
	static doRecordRestore(task,formModule)
	{
		var _group = CommandResolver.getTaskGroup(task, formModule);
		if(!_group)
			return;
		var sync = false;
		var updateRelate = true;
		if(task)
		{
			if(typeof(task.arg) == "boolean")
			{
				updateRelate = task.arg;
			}
			else if(typeof(task.arg)=="object")
			{
				if(task.arg.hasOwnProperty("sync"))
					sync = task.arg.sync;
				if(task.arg.hasOwnProperty("updateRelate"))
					updateRelate = task.arg.updateRelate;
			}
		}
		_group.doRecordRestore(sync,updateRelate,false);
	}

	static refreshToolBar(group)
	{
		if(group.formDataSources.formModule.classAlias!="FormModuleLookup")
			group.activeToolBarByRecord(group.currentRecord);
	}
	
	static doDsAllowEdit(task,formModule)
	{
		var group = CommandResolver.getTaskGroup(task,formModule);
		if(group)
		{
			group.ds_AllowEdit = task.arg;
			CmdTypeActions.dsAllowEdit(group.groupAlias);
		}
	}

	static doDsAllowAdd(task,formModule)
	{
		var group = CommandResolver.getTaskGroup(task,formModule);
		group.ds_AllowAdd = task.arg;
		CommandResolver.refreshToolBar(group);
	}

	static doDsAllowAttachment(task,formModule)
	{
		var group = CommandResolver.getTaskGroup(task,formModule);
		group.ds_AllowAttachment = task.arg;
		CommandResolver.refreshToolBar(group);
	}
	
	static doDsAllowDelete(task,formModule)
	{
		var group = CommandResolver.getTaskGroup(task,formModule);
		group.ds_AllowDelete = task.arg;
		CommandResolver.refreshToolBar(group);
	}
	
	static doDsAllowExport(task,formModule)
	{
		var group = CommandResolver.getTaskGroup(task,formModule);
		group.ds_AllowExport = task.arg;
		CommandResolver.refreshToolBar(group);
	}
	
	static doDsAllowQuery(task,formModule)
	{
		var group = CommandResolver.getTaskGroup(task,formModule);
		group.ds_AllowQuery = task.arg;
		CommandResolver.refreshToolBar(group);
	}
	
	static doDsAllowSave(task,formModule)
	{
		var group = CommandResolver.getTaskGroup(task,formModule);
		group.ds_AllowSave = task.arg;
		CommandResolver.refreshToolBar(group);
	}

	static setControlFocus(task,formModule)
	{
		var controlItem = FormItemUtil.getFormItemControl("ctrl_"+task.control,formModule.classAlias=="FormModuleLookup"?true:false);
		FocusActions.focusSet(formModule.formId,controlItem.xml.id);
		formModule.setBeforeInitFocusInControlId(controlItem.xml.id);
		/*
		var formItem:GongqiFormItem = formDesign.items["ctrl_"+id] as GongqiFormItem;
		if(formItem && formItem.control == null)
		{
			formDesign.formModule.setBeforeInitFocusInControlId("ctrl_"+id);
		}
		else
		{
			formDesign.formModule.focusController.findControlAndSetFocus("ctrl_"+id);
		}*/
	}

	static changeTabPage(task,formModule)
	{
		var newIndex = 0;
		var tabPageName = task.control;
		var formitemtabpage = FormItemUtil.getFormItemControl("ctrl_"+tabPageName,false);
		if(!formitemtabpage)
			return;
		var formItem = formitemtabpage.parentControl;
		newIndex = formItem.childrenControl.indexOf(formitemtabpage);
		
		if(formItem.classAlias == "FormItemTabControl")
		{
			/*var tab:TabNavigator = TabNavigator(FormItem_Tab(formItem).control);
			if(tab)
			{
				var index:int = tab.selectedIndex;
				if(newIndex == index)
					return;
				var total:int = tab.numChildren;
				if(total == 0)
					return;
				if(newIndex>=total)
					newIndex = 0;
			}*/

			let switchArg = {tabName:formItem.xml.name,moduleInstanceId:formModule.instanceUUId,newIndex:newIndex,complete:false};
			CmdTypeActions.switchTabPage(switchArg);
			if(!switchArg.complete)
			{
				let wrapindex = newIndex;
				let formitem_tabpage = formItem.childrenControl[wrapindex];
				if(formitem_tabpage && formitem_tabpage.getProperty_Visible_Final() == false)
					return;
				
				formItem.setInitSelectIndex(newIndex);
				//TODO 如果是在beforeInit中做二次开发 是否考虑对于自动定位的影响
				//formDesign.formModule.setBeforeInitChangeTabPage(true);
			}
			
		}
	}

	static doRecordConditionTask(task,formModule)
	{
		var jca = task.arg;
		if(!jca)
			return;
		var group = CommandResolver.getTaskGroup(task,formModule);
		if(!group)
			return;
		if(!jca.isNull){
			// currentRecord
			if(group.analysisConditionSingleRecord(null,jca))
			{
				CommandResolver.resolve(jca.trueCommandResult.tasks.concat(), formModule);
			}
			else if(jca.falseCommandResult && jca.falseCommandResult.tasks && jca.falseCommandResult.tasks.length>0)
			{
				CommandResolver.resolve(jca.falseCommandResult.tasks.concat(),formModule);
			}
		}else{
			group.afterRecordConditionTask = task.arg;
		}
	}

	static analysisConditionSingleValue(callerDataField,callerMenuItemId, menuItemId, value, formParamCondition)
	{
		if(!formParamCondition)
			return true;
		if(!formParamCondition.getSqlWhereStr)
			formParamCondition.getSqlWhereStr = FormParamCondition.getSqlWhereStr;
		var ws = formParamCondition.getSqlWhereStr();
		//对象中的函数要删掉 如果在beforeInit中执行 逻辑执行会在存储到H5Storage之前 则造成Storage put失败 因为函数无法clone
		delete formParamCondition.getSqlWhereStr;
		if(ws == "")
			return true;
		var wsa = ws.split(" ");
		var wsr = "";
		for(let i = 0;i<wsa.length;i++)
		{
			let s = wsa[i];
			if(s.indexOf("=") == -1)
			{
				wsr += s;
			}
			else
			{
				var fn = StringUtil.convertToFirstLowerCase(s.substring(0,s.indexOf("=")));
				var fv = s.substr(s.indexOf("=")+1);
				
				if(fn.indexOf(".") != 0) //fn == .fieldName
					continue;
				if(RecordsUtil.analysisValue((fn==".menuItemId"?menuItemId:(fn==".callerMenuItemId"?callerMenuItemId:(fn==".callerLookupField"?callerDataField:value))),fv))
				//if(RecordsUtil.analysisValue((fn==".menuItemId"?menuItemId:value),fv))
				{
					wsr+="1";
				}
				else
				{
					wsr+="0";
				}
			}
			
		}
		
		return StringUtil.evalLEString(StringUtil.trimThrough(wsr));
	}

	static doFormParamConditionTasks(task,formModule)
	{
		var list;
		if(Array.isArray(task.arg))
			list = task.arg;
		else
			list = [task.arg];
		for(let i = 0;i<list.length;i++)
		{
			let ca = list[i];
			var menuItemId = formModule.menuItemId;
			//不支持自定义下拉框
			var parameters = window.argCaller?window.argCaller.parameters:null;
			if(!menuItemId && !parameters)
				return;
			var isLookup = (formModule.classAlias == "FormModuleLookup");
			var caller = isLookup?formModule.props.argCaller:window.argCaller;
				//formDesign.formModule.argCaller.caller as FormModule; 
			
			var callerMenuItemId = caller?caller.callerMenuItemId:"null";
			var callerDataField = caller?caller.callerDataField:"null";
			if(!menuItemId && !parameters && !callerMenuItemId && !callerDataField)
				return;

			var bool = CommandResolver.analysisConditionSingleValue(callerDataField,callerMenuItemId,menuItemId, parameters, ca.formParamCondition);
			if(bool)
			{
				var commandResult = ca.trueCommandResult;
			}
			else
			{
				commandResult = ca.falseCommandResult;	
			}
			
			if(!commandResult)
				continue;
			else if(commandResult.tasks)
				CommandResolver.resolve(commandResult.tasks.concat(), formModule);
		}
	}

	static doFormContext(task,formModule)
	{
		if(typeof(task.arg)=="object")
		{
			var fca = task.arg;
			if(fca.cmdType == ContextMapArg.PUT)
			{
				formModule.contextMap[fca.key] = fca.value;
			}
			else if(fca.cmdType == ContextMapArg.REMOVE)
			{
				delete formModule.contextMap[fca.key];
			}
			else if(fca.cmdType == ContextMapArg.CLEAR)
			{
				formModule.contextMap = {};
			}
			
		}
	}

	static showDialog(task,formModule)
	{
		var $dialogModal = $("#dialogModal");
		var modalDiv = $("<div>").addClass("modal").css("display","flex").css("align-items","center")
								 .css("justify-content","center").appendTo($dialogModal);
		ReactDOM.render(<DialogForm dialogArg={task.arg}/>,modalDiv[0]);
      	
	}

	static doRefreshPlugin(task,formModule)
	{
		let result = [];
		CmdTypeActions.refreshPlugin(task,task.control,formModule.formId,result);
		if(result.length == 0)
		{
			let key = "pluginLaterArg."+formModule.formId+"."+task.control;
			if(!window[key])
				window[key] = {tasks:[task]}
			window[key].tasks.push(task);
		}
	}

	static addTimer(task,formModule)
	{
		let timerTaskRemote = task.arg;
		var timerHandlerFunction = function()
		{
			CommandResolver.timerHandler(timerTaskRemote.formCmd, timerTaskRemote.formCmdArgObject,formModule);
		}
			
		TimerTasksUtil.addTimer(timerTaskRemote.timerId,timerTaskRemote.delay,timerHandlerFunction,timerTaskRemote.repeatCount)
		
	}

	static cancelTimer(task,formModule)
	{
		let timerId = task.arg;
		TimerTasksUtil.cancelTimer(timerId);
	}

	static timerHandler(formCmdMethodName, formCmdArgObject,formModule)
	{
		var arg = {};
		arg["methodName"] = formCmdMethodName;
		arg["methodArg"] = formCmdArgObject;
		var commandTask = new CommandTask();
		commandTask.cmd = Cmd.FormCmd;
		commandTask.arg = arg;
		CommandResolver.formCmd(commandTask,formModule);
	}

	static doSetFormTitle(task,formModule)
	{
		 var _parentWindow = window.parent.window;
		 if(_parentWindow)
	     {
	        if(!window.isPopUp)
	        {
	          _parentWindow.setFormLabel(window.formModuleInstanceuuId,task.arg);  
	        }
	        else
	        {
				formModule.formLabel = task.arg;
				let propFormName = formModule.formName;
				if(propFormName)
				{
					let formNameChanged = propFormName.replace(/\./g,"_");
					let titleDomSelector = "#app>#"+formNameChanged+" .modal-title";
					$(titleDomSelector).text(task.arg);
				}	
				
	        }
	     }
	}

	static restoreParent(task,formModule,tasks)
	{
		var _group = CommandResolver.getTaskGroup(task, formModule);
		if(!_group && formModule.formDataSources)
		{
			_group = formModule.formDataSources.currentGroup;
		}
		
		if(_group && _group.linkGroup && _group.linkGroup.currentRecord)
		{
			let _parentGroup = _group.linkGroup;
			//TODO 原来Flex在这个命令中只恢复currentRecord 没有考虑到selectedRecords的情况CommandResolver.setFormDataSourceGroupArg(_parent, _arg);
			//if(_arg.recordCounts==1)
			window.remainTasks = tasks;
			_parentGroup.doRecordRestore(true,task.arg,false);
			let formModule1 = _parentGroup.formDataSources.formModule;
			let formModule2 = window.formModuleInstance;
			if(formModule1 && formModule2)
			{
				if(formModule1.instanceUUId != formModule2.instanceUUId)
					return false;
			}
			return true;
		}
		else
		{
			if(window.argCaller && window.argCaller.joinGroupAlias)
			{
				var _parentWindow = window.parent.window;
				let formInstance = _parentWindow.getFormInstanceByUUID(argCaller.calleruuId);

				if(formInstance && formInstance.formDataSources && formInstance.formDataSources.sources)
				{
					let _parentGroup = formInstance.formDataSources.groups[window.argCaller.joinGroupAlias];
					if(_parentGroup)
					{
						_parentGroup.doRecordRestore(true,task.arg,false);
					}
					else
					{
						Warning.show({text:"由于找不到父页面或没有找到父页面的数据源 所以无法执行RestoreParent"});
					}
				}
				else
				{
					Warning.show({text:"由于找不到父页面或没有找到父页面的数据源 所以无法执行RestoreParent"});
				}
			}
			else
			{
				Warning.show({text:"由于找不到父页面 所以无法执行RestoreParent"});
			}
		}
	}

	static doClientRecordRemove(task,formModule)
	{
		var group = CommandResolver.getTaskGroup(task, formModule);
		if(Array.isArray(task.arg))
			group.deleteRecordOnClient(task.arg);
		else
			group.deleteRecordOnClient([task.arg]);
	}

	static doSetControlProperty(task,formModule)
	{
		if(Array.isArray(task.arg))
		{
			for(let i = 0;i<task.arg.length;i++)
			{
				let cpi = task.arg[i];
				let key;
				if(formModule.classAlias == "FormModuleLookup")
				{
					key = "FormLookup."+formModule.formId+"."+cpi.controlName;
				}
				else
				{
					key = "ctrl_"+cpi.controlName;
				}
				
				let gongqiFormItem = FormItemUtil.getFormItemControl(key,formModule.classAlias=="FormModuleLookup"?true:false);
				if(gongqiFormItem)
				{
					gongqiFormItem.setControlProperty(cpi.propertyName,cpi.propertyValue);
				}
			}
		}
		else
		{
			let cpi = task.arg;
			let key;
			if(formModule.classAlias == "FormModuleLookup")
			{
				key = "FormLookup."+formModule.formId+"."+cpi.controlName;
			}
			else
			{
				key = "ctrl_"+cpi.controlName;
			}
			let gongqiFormItem = FormItemUtil.getFormItemControl(key,formModule.classAlias=="FormModuleLookup"?true:false);
			if(gongqiFormItem)
			{
				gongqiFormItem.setControlProperty(cpi.propertyName,cpi.propertyValue);
			}
		}
	}

	static isExtendsDataTypeArrayItem(formItem,ainame,fieldgroupxml)
	{
		var cmpPro = GOTUtil.getProperty(fieldgroupxml,"Component");
		if(cmpPro.hasOwnProperty("refinnerid") || cmpPro.hasOwnProperty("refentityid"))
		{
			var extendsValue = formItem.xml.name;//GOTHelper.getPropertyValue(formItem.xml,"Extends");
			if(extendsValue)
			{
				var _index = extendsValue.lastIndexOf("_");
				if(_index!=-1)
				{
					var datatypearrayitemname = extendsValue.substr(_index+1);
				}
				else
				{
					datatypearrayitemname = extendsValue;
				}
				if(datatypearrayitemname == ainame)
					return true;
			}
		}
		else
		{
			var _name = fieldgroupxml.name;
			if(_name.indexOf("DimSelect_") == 0)
			{
				var itemName = formItem.xml.name;
				if(itemName.indexOf(_name) == 0)
				{
					if(itemName == ainame)
						return true;
				}
			}
		}
		return false;
	}

	static doSortFormItem(task,formModule)
	{
		let key;
		if(formModule.classAlias=="FormModuleLookup")
		{
			key = "FormLookup." + formModule.formId + "." + task.control;
		}
		else
		{
			key = "ctrl_"+task.control;
		}
		var parentControl = FormItemUtil.getFormItemControl(key,formModule.classAlias=="FormModuleLookup"?true:false);
		if(parentControl)
		{
			var fieldgroupxml = parentControl.xml;
			fieldgroupxml.FormItem = [];
			var array = task.arg;//array = ["Grade","Config","Color","Size","Serial","Batch"];
			var bak = parentControl.childrenControl;
			
			var nvector = [];
			for(let i = 0;i<array.length;i++)
			{
				let item = array[i];
				for(let j=0;j<bak.length;j++)
				{
					var bakitem = bak[j];
					if(bakitem && bakitem.xml.name == item)
					{
						nvector.push(bakitem);
						fieldgroupxml.FormItem.push(bakitem.xml);
						bak[j] = null;
					}
				}
				
			}
			
			for(let i = 0;i<bak.length;i++)
			{
				let bakitem = bak[i]
				if(bakitem)
				{
					nvector.push(bakitem);
					fieldgroupxml.FormItem.push(bakitem.xml);
				}
			}
			
			parentControl.childrenControl = nvector;
			//重新赋值 原因应该为重新构造焦点管理 默认设置已经被改变 不需要删除
			formModule.focusController = new FocusController(formModule.props.xml.FormDesign,formModule);
		}
	}

	static doSortComponent(task,formModule)
	{
		let key;
		if(formModule.classAlias=="FormModuleLookup")
		{
			key = "FormLookup." + formModule.formId + "." + task.control;
		}
		else
		{
			key = "ctrl_"+task.control;
		}
		var fieldgroup = FormItemUtil.getFormItemControl(key,formModule.classAlias=="FormModuleLookup"?true:false);
		if(fieldgroup)
		{
			var fieldgroupxml = fieldgroup.xml;
			fieldgroupxml.FormItem = [];
			var array = task.arg;
			//array = ["Grade","Config","Color","Size","Serial","Batch"];
			var bak = fieldgroup.childrenControl;
			
			var nvector = [];
			for(let i = 0;i<array.length;i++)
			{
				let item = array[i];
				for(let j=0;j<bak.length;j++)
				{
					var bakitem = bak[j];
					if(bakitem && CommandResolver.isExtendsDataTypeArrayItem(bakitem,item,fieldgroupxml))
					{
						nvector.push(bakitem);
						fieldgroupxml.FormItem.push(bakitem.xml);
						bak[j] = null;
					}
				}
				
			}
			
			for(let i = 0;i<bak.length;i++)
			{
				let bakitem = bak[i]
				if(bakitem)
				{
					nvector.push(bakitem);
					fieldgroupxml.FormItem.push(bakitem.xml);
				}
			}
			
			fieldgroup.childrenControl = nvector;
			//重新赋值 原因应该为重新构造焦点管理 默认设置已经被改变 不需要删除
			formModule.focusController = new FocusController(formModule.props.xml.FormDesign,formModule);
		}
	}

	static doDimAdjustFormDataSourceField(task,formModule)
	{
		if(!formModule.dimAdjustFormDataSourceField){formModule.dimAdjustFormDataSourceField=task.arg}else{
			for(let i in formModule.dimAdjustFormDataSourceField){
				let map = formModule.dimAdjustFormDataSourceField[i];
				let map2 = task.arg[i];
				for(let dataSource in map2){
					if( map && map[dataSource]){
						Object.assign(map[dataSource],map2[dataSource])
					}else if(!map){
						map={};
						map[dataSource] = {};
						Object.assign(map[dataSource],map2[dataSource])
						formModule.dimAdjustFormDataSourceField[i] = map;
					}else{
						if(!map[dataSource]){
							map[dataSource] = {};
						}
						Object.assign(map[dataSource],map2[dataSource])
					}
				}
				// for(let j in task.arg){
				// 	if(i == j ){
				// 		if(map || task.arg[j]){
				// 			if(!map)map={};
				// 			if(!task.arg[j])task.arg[j]={};
				// 			Object.assign(map,task.arg[j])
				// 		}
				// 	}
				// }
			}
		};
	}

	static doShowInfo(task)
	{
		let arg = task.arg;
		Warning.show({text:arg.info,state:"info",title:arg.title});
		//GlobalInfoDisplayer.show(task.arg as ShowInfoArg);
	}

	static deleteTempRecord(task,formModule)
	{
		var _group = CommandResolver.getTaskGroup(task, formModule);
		if(_group)
		{
			var queryTable = task.arg;
			if(queryTable)
			{
				_group.deleteTempRecords(queryTable);
			}
		}
	}

	static activeRecord(task,formModule)
	{
		var _group = CommandResolver.getTaskGroup(task, formModule);
		if(_group)
			_group.activeRecordRemote();
	}

	static updateToolBar(task,formModule) 
	{
		if(formModule)
			formModule.updateToolBar(task.arg);
	}

	static doClientRecordAdd(task,formModule)
	{
		//alert("clientRecordAdd");
		if(!task.arg)
			return;
		var _group = CommandResolver.getTaskGroup(task, formModule);
		if(_group)
		{
			if(task.arg.location)
				_group.rpc_result_doRecordNew2({result:task.arg.data,location:task.arg.location});
			else
				_group.rpc_result_doRecordNew2({result:task.arg});
		}

	}

	static writeField(task,formModule)
	{
		var _group = CommandResolver.getTaskGroup(task, formModule);
		if(_group)
		{
			let resultValue = {};
			if(task.control)
			{
				resultValue[task.control] = task.arg;
			}
			else
			{
				resultValue = task.arg;
			}
			_group.doWriteField(resultValue,true);
		}
		
	}

	static doWriteField(task,formModule)
	{
		var _group = CommandResolver.getTaskGroup(task, formModule);
		if(_group)
		{
			let resultValue = {};
			if(task.control)
			{
				resultValue[task.control] = task.arg;
			}
			else
			{
				resultValue = task.arg;
			}
			_group.doWriteField(resultValue,false);
		}
	}

	static doWriteDataMethodField(task,formModule)
	{
		let _group = CommandResolver.getTaskGroup(task,formModule);
		if(_group && task.arg)
		{
			_group.updateDataMethodFieldValue(task.arg);
		}
	}

	static holdFocusIn(task,formModule)
	{
		var controlItem = FormItemUtil.getFormItemControl("ctrl_"+task.control,formModule.classAlias=="FormModuleLookup"?true:false);
		FocusActions.holdFocusIn(formModule.formId,controlItem.xml.id);
		controlItem.holdFocus = true;
	}

	static registerRender(task,formModule)
	{
		let resultValue = {};
		if(task.control)
		{
			resultValue[task.control] = {render:task.arg,editable:task.editorEditable};
		}
		else
		{
			resultValue = task.arg;
		}
		Object.assign(formModule.rendersObject,resultValue);
	}

	static dragStart(task,formModule)
	{
		let dragStartHandler = task.arg;
		let resultValue = {};
		let columnName = task.control;
		if(columnName)
		{
			resultValue[columnName] = {handler:dragStartHandler};
		}
		
		Object.assign(formModule.dragStartObjects,resultValue);
	}

	static showCalculator(task,formModule)
	{
		if(task.arg && typeof(task.arg) == "function")
			window.parent.window.showCaculator("clear",task.arg);
	}

	static updateDropDownContent(task,formModule)
	{
		if(task.arg)
		{
			CmdTypeActions.updateDropDownContent(task.arg,task.control,formModule.instanceUUId);
		}
	}

	static doSysReinitForm(task,formModule,tasks)
	{
		if(task.arg)
		{
			let _formId = task.arg;
			if(window.doReinitForm1)
				window.doReinitForm1(_formId,formModule,tasks);
		}
	}

	static showClipboard(task,formModule)
	{
		if(task.arg)
		{
			var container = document.getElementById('remotePasteDialogModal');
			//if(window.parent){window.parent.window.showClipboard(task);return;}
				//container = window.parent.document.getElementById('remotePasteDialogModal');
			ReactDOM.render(<RemotePasteDialog remotearg={task.arg} task={task}/>,container);
			$(container).css("display","flex");
		}
	}

	static showImage(task,formModule)
	{
		let source = task.arg;
		/*if(typeof(source) == "string")
		{
			var controlItem = FormItemUtil.getFormItemControl("ctrl_"+task.arg,false);
			if(controlItem && controlItem.classAlias == "FormItemImageControl")
			{
				return;
			}
		}*/

		if(source)
		{
			if(source.indexOf("http://") == 0)
			{
				$("#global_ShowImageCmdHelpImg").attr("src",source);
			}
			else if(source.indexOf("data:image/") == 0)
			{
				$("#global_ShowImageCmdHelpImg").attr("src",source);
			}
			else
			{
				$("#global_ShowImageCmdHelpImg").attr("src","data:image/jpeg;base64,"+source);
			}
			
			//$("#global_ShowImageCmdHelpDiv").viewer({url: 'data-original',navbar:false,fullscreen:false});
			$("#global_ShowImageCmdHelpDiv").viewer("show");
		}
	}

	static CallClientMethod(task,formModule)
	{
		LayerManager.executeLayerMethod(formModule,null,task.control,task.arg);
	}

	static clientSelectRecords(task,formModule)
	{
		CmdTypeActions.selectRecords(task);
	}

	static dsAttachmentAllowDelete(task,formModule)
	{
		formModule.dsAttachmentAu["del"] = task.arg;
	}
	static dsAttachmentAllowRename(task,formModule)
	{
		formModule.dsAttachmentAu["rename"] = task.arg;
	}
	static dsAttachmentAllowUpload(task,formModule)
	{
		formModule.dsAttachmentAu["upload"] = task.arg;
	}
	static dsAttachmentAllowVisible(task,formModule)
	{
		formModule.dsAttachmentAu["visible"] = task.arg;
	}
	static doOpenLuckySheet(task,formModule)
	{
		if(task.arg)
		{
			let _fileId = JSON.parse(task.arg);
			var _parentWindow = (window.didomain)?window:window.parent.window;
			if (_parentWindow.didomain && !_parentWindow.loginToken && !_parentWindow.loginDataArea){
					if(typeof(window.openTemplateDesign()) == 'function'){
					   _parentWindow =window;
					}else if(typeof(window.parent.window.openTemplateDesign()) == 'function'){
					   _parentWindow =window.parent.window;
					}else{
					   _parentWindow =window.parent.parent.window;
					}
					_parentWindow.openTemplateDesign(_fileId);
			}else{
				
				if(window.openLuckySheet && typeof(window.openLuckySheet) == 'function'){
					_parentWindow =window;
				 }else if(window.parent.openLuckySheet && typeof(window.parent.window.openLuckySheet) == 'function'){
					_parentWindow =window.parent.window;
				 }else{
					_parentWindow =window.parent.parent.window;
				 }
				 _parentWindow.menuItemId = formModule.menuItemId
				 _parentWindow.formModuleInstance = formModule;
				 _parentWindow.openLuckySheet(_fileId);
			}
		}
	}
	static doUpdateAllowEditorNotSelectAll(task,formModule)
	{
	
		let _parentWindow =window;	
		if(window.notClickFocusEditors && typeof(window.updateEditorNotClickFocus) == 'function'){
			_parentWindow =window;
		}else if(window.parent.window.notClickFocusEditors && typeof(window.parent.window.updateEditorNotClickFocus) == 'function'){
			_parentWindow =window.parent.window;
		}else{
			_parentWindow =window.parent.parent.window;
		}
		 _parentWindow.menuItemId = formModule.menuItemId
		 _parentWindow.formModuleInstance = formModule;
		 if(_parentWindow.notClickFocusEditors){ 
			 _parentWindow.updateEditorNotClickFocus(task.arg,formModule);
		 }
	}

	static doPrintReport(task,formModule){
		let _parentWindow =window;	
		if(window.doPrintReport && typeof(window.doPrintReport) == 'function'){
			_parentWindow =window;
		}else if(window.parent.window.doPrintReport && typeof(window.parent.window.doPrintReport) == 'function'){
			_parentWindow =window.parent.window;
		}else{
			_parentWindow =window.parent.parent.window;
		}
		 if(_parentWindow.doPrintReport){ 
			 _parentWindow.doPrintReport(task,formModule);
		 }
	}

}

export default CommandResolver;


// WEBPACK FOOTER //
// ./src/utils/CommandResolver.js